export default {"src":"/_next/static/media/Nationwide-network-blue.b89ace8c.svg","height":1600,"width":1600};